import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled, { css } from "styled-components"
import BarleyImage from "./BarleyImage"
// import { Family } from "./Family"
import { FeaturedFamily } from "./FeaturedFamily"
import { Headline } from "../../components"
import { media } from "../../../../styles/media"

const query = graphql`
  {
    strapiIndexPage {
      ourFamilies {
        familyTitleEn
        familyTitleJp
        familiesList {
          id
          productPageUrl
          specialPageUrl
          brandLogo {
            childImageSharp {
              fluid(quality: 100) {
                ...GatsbyImageSharpFluid_tracedSVG
              }
            }
          }
          brandVisual {
            childImageSharp {
              fluid(quality: 80) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  }
`

const StyledContainer = styled.div`
  padding: 50px 5%;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colors.light.brown};
  position: relative;
`

const StyledFeaturedFamilySection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 20px;
  row-gap: 50px;
  margin-block: 30px;

  ${() =>
    media.sp(css`
      grid-template-columns: 1fr 1fr;
      flex-flow: column nowrap;
      margin-block-end: 24px;
      row-gap: 50px;
    `)}

  @media screen and (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`

// currently not used because Omochiya is deleted from the list
// const StyledFamilySection = styled.div`
//   width: 100%;
//   padding: 30px 0;
//   display: flex;
//   flex-flow: row wrap;
//   justify-content: flex-start;
//   position: relative;

//   ${() =>
//     media.sp(css`
//       padding: 0 0 30px;
//     `)}
// `

const OurFamilies = () => {
  const {
    strapiIndexPage: {
      ourFamilies: { familyTitleEn, familyTitleJp, familiesList },
    },
  } = useStaticQuery(query)
  const renderedFamilies = familiesList.filter(
    family =>
      family.productPageUrl !== "/francois-bread/" &&
      family.productPageUrl !== "/omochiya/"
  )
  return (
    <StyledContainer id="familyAnchor">
      <Headline titleJp={familyTitleJp} titleEn={familyTitleEn} />
      <BarleyImage />
      <StyledFeaturedFamilySection>
        {renderedFamilies.map(family => (
          <FeaturedFamily
            key={family.id}
            logoImage={family.brandLogo.childImageSharp.fluid}
            brandVisualImage={family.brandVisual.childImageSharp.fluid}
            productPageUrl={family.productPageUrl}
            specialPageUrl={family.specialPageUrl}
          />
        ))}
      </StyledFeaturedFamilySection>
      {/* <StyledFamilySection>
        {familiesList.slice(3).map(family => {
          if (family.productPageUrl !== "/francois-bread/") {
            return (
              <Family
                key={family.id}
                logoImage={family.brandLogo.childImageSharp.fluid}
                brandVisualImage={family.brandVisual.childImageSharp.fluid}
                productPageUrl={family.productPageUrl}
                specialPageUrl={family.specialPageUrl}
              />
            )
          }
        })}
      </StyledFamilySection> */}
    </StyledContainer>
  )
}

export default OurFamilies
